import create from "zustand";
import { persist } from "zustand/middleware";
import { legendsLevelNumber } from "../utils/legendsLevels";

const useLegendsStore = create(
  persist(
    (set, get) => ({
      lastPlayed: null,
      saveLastPlayed: (number) =>
        set(() => ({
          lastPlayed: number,
        })),

      silhouetteOn: 0,
      saveSilhouetteOn: (attempt) =>
        set(() => ({
          silhouetteOn: attempt,
          lastPlayed: legendsLevelNumber,
        })),
      resetSilhouetteOn: () =>
        set(() => ({
          silhouetteOn: 0,
        })),

      guesses: [],
      saveGuess: (player) =>
        set((prevState) => ({
          guesses: [...prevState.guesses, player],
          lastPlayed: legendsLevelNumber,
        })),
      resetGuesses: () =>
        set(() => ({
          guesses: [],
        })),

      history: {},
      saveHistory: (result) => {
        return set((prevState) => ({
          history: Object.assign(prevState.history, {
            [legendsLevelNumber]: result,
          }),
        }));
      },

      instructionsDismissed: false,
      saveInstructionsDismissed: (isDismissed) =>
        set(() => ({
          instructionsDismissed: isDismissed,
        })),
    }),
    {
      name: "legends",
      getStorage: () => localStorage,
      merge: (persistedState, currentState) => {
        if (persistedState.lastPlayed !== legendsLevelNumber) {
          console.log(
            `level change ${persistedState.lastPlayed} -> ${legendsLevelNumber}, clearing guesses and silhouetteOn`
          );
          persistedState.guesses = [];
          persistedState.silhouetteOn = 0;
        }

        return { ...currentState, ...persistedState };
      },
    }
  )
);

export default useLegendsStore;
